// extracted by mini-css-extract-plugin
export default {"container":"wj-z","links":"xj-z"};